import { IntentStatus } from '@40seas/entities/intents';
import { EnumColor } from '@40seas/frontend/common/providers';

export const intentStatusColorMapping = {
    [IntentStatus.Active]: 'default',
    [IntentStatus.Inactive]: 'error',
    [IntentStatus.Done]: 'success',
} as { [key in IntentStatus]: EnumColor };
